import { render } from "./UserShowOffcanvas.vue?vue&type=template&id=72db216f&scoped=true"
import script from "./UserShowOffcanvas.vue?vue&type=script&lang=js"
export * from "./UserShowOffcanvas.vue?vue&type=script&lang=js"

import "./UserShowOffcanvas.vue?vue&type=style&index=0&id=72db216f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72db216f"]])

export default __exports__